import { Component, Element, Host, Prop, Watch, h } from '@stencil/core';
import { HTMLStencilElement } from '@stencil/core/internal';
import { generateCssClasses } from '../../utils/generate-css-classes';

/*
Circumference of spinner circle:
r = 18
2πr = 36π ≈ 113.097
*/

@Component({
	shadow: true,
	styleUrl: 'zds-spinner.scss',
	tag: 'zds-spinner',
})
export class ZdsSpinner {
	spinnerCircleElement: SVGElement;

	@Element() hostElement: HTMLStencilElement;

	@Prop() indeterminate: boolean;
	@Prop() progress: number;

	@Watch('progress')
	onProgressChange() {
		this.updateProgress();
	}

	componentDidLoad() {
		this.updateProgress();
	}

	render() {
		const cssClasses = generateCssClasses('zds-spinner', {
			indeterminate: !!this.indeterminate,
		});

		return (
			<Host
				aria-valuemax="1"
				aria-valuemin="0"
				aria-valuenow={this.indeterminate ? undefined : this.progress}
				role="progressbar"
			>
				<div class={cssClasses}>{this.renderSpinner()}</div>
			</Host>
		);
	}

	renderSpinner() {
		return (
			<div class="zds-spinner__spinner-container">
				<svg class="zds-spinner__spinner-svg" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
					<circle
						class="zds-spinner__spinner-circle"
						cx="24"
						cy="24"
						r="18"
						stroke-dasharray="113.097"
						stroke-dashoffset="113.097"
						stroke-width="4"
						ref={(element) => (this.spinnerCircleElement = element)}
					/>
				</svg>
			</div>
		);
	}

	updateProgress() {
		const circumference = 2 * Math.PI * 18;

		let dashOffset: number;
		if (this.indeterminate) {
			dashOffset = 0.2 * circumference;
		} else {
			dashOffset = (1 - this.progress) * circumference;
		}

		this.spinnerCircleElement.setAttribute('stroke-dashoffset', dashOffset.toString());
	}
}
